import React from 'react';
import { Box } from '@chakra-ui/react';
import About from '../components/ui/About';

const AboutPage = () => {
  return (
    <Box pt={20}>
      <About />
    </Box>
  );
};

export default AboutPage;